import { deleteUser } from '@cannect/hooks/useSessionUser'
import { useTokenApi } from '@cannect/hooks/useTokenApi'
import { Separator } from '@cannect/new-components/atoms'
import useSignedUser from 'hooks/useSignedUser'
import { BiLogOut } from 'react-icons/bi'
import { useHistory } from 'react-router-dom'
import CollapsableMenu from './components/CollapsableMenu'
import HelloMessage from './components/HelloMessage'
import { PATIENT_SIDE_PANEL } from './constants/patient'
import * as Styles from './styles'

function AccountSidePanel() {
  const { signedUser } = useSignedUser()
  const { deleteTokenApi, tokenApi } = useTokenApi()
  const history = useHistory()

  const handleLogout = () => {
    try {
      localStorage.removeItem('association_order_id')
    } catch (error) {
      console.error('Error clearing cart:', error)
    }
    deleteTokenApi()
    deleteUser()
    history.push('/AreaAssociados')
  }

  return (
    <Styles.AccountSidePanelContainer>
      <HelloMessage />
      <Separator className="my-4" />
      {PATIENT_SIDE_PANEL.map((item) => (
        <CollapsableMenu title={item.title} subItems={item?.subItems} key={item.title.label} />
      ))}
      <Separator className="my-4" />
      <Styles.LogoutButtonContainer>
        <BiLogOut size={20} />
        <Styles.LogoutButton onClick={handleLogout}>Sair</Styles.LogoutButton>
      </Styles.LogoutButtonContainer>
    </Styles.AccountSidePanelContainer>
  )
}

export default AccountSidePanel
